import type { Translate } from '@/utils/hooks/translation/useTranslation';

export type ToneOfVoiceType =
    | 'friendly'
    | 'formal'
    | 'directive'
    | 'convincing'
    | 'informative'
    | 'empathetic'
    | 'humorous'
    | 'serious';

type ToneOfVoiceOptionsType = { label: string } & (
    | { value: ToneOfVoiceType }
    | { value: undefined }
);

export const toneOfVoiceOptions = (t: Translate) =>
    [
        {
            label: t('scheduler.scheduler_funnel.ai_caption.modal.tone_of_voice_placeholder'),
            value: undefined
        },
        {
            label: t('ai_caption:tone_of_voice.friendly'),
            value: 'friendly'
        },
        {
            label: t('ai_caption:tone_of_voice.formal'),
            value: 'formal'
        },
        {
            label: t('ai_caption:tone_of_voice.directive'),
            value: 'directive'
        },
        {
            label: t('ai_caption:tone_of_voice.convincing'),
            value: 'convincing'
        },
        {
            label: t('ai_caption:tone_of_voice.informative'),
            value: 'informative'
        },
        {
            label: t('ai_caption:tone_of_voice.empathetic'),
            value: 'empathetic'
        },
        {
            label: t('ai_caption:tone_of_voice.humorous'),
            value: 'humorous'
        },
        {
            label: t('ai_caption:tone_of_voice.serious'),
            value: 'serious'
        }
    ] as ToneOfVoiceOptionsType[];

export function toneOfVoiceSubmenu(
    t: Translate,
    callback: (param: ToneOfVoiceType) => Promise<void>
) {
    const options = toneOfVoiceOptions(t).filter((option) => option.value);

    return options.map((option) => {
        return { ...option, callback: () => callback(option.value) };
    });
}

export const captionAiToneOfVoiceOptions = (t: Translate) =>
    [
        {
            label: t('caption.ai_caption.tone_of_voice.placeholder'),
            value: undefined
        },
        {
            label: t('ai_caption:tone_of_voice.friendly'),
            value: 'friendly'
        },
        {
            label: t('ai_caption:tone_of_voice.formal'),
            value: 'formal'
        },
        {
            label: t('ai_caption:tone_of_voice.directive'),
            value: 'directive'
        },
        {
            label: t('ai_caption:tone_of_voice.convincing'),
            value: 'convincing'
        },
        {
            label: t('ai_caption:tone_of_voice.informative'),
            value: 'informative'
        },
        {
            label: t('ai_caption:tone_of_voice.empathetic'),
            value: 'empathetic'
        },
        {
            label: t('ai_caption:tone_of_voice.humorous'),
            value: 'humorous'
        },
        {
            label: t('ai_caption:tone_of_voice.serious'),
            value: 'serious'
        }
    ] as ToneOfVoiceOptionsType[];

export function captionAiToneOfVoiceSubmenu(
    t: Translate,
    callback: (param: ToneOfVoiceType) => Promise<void>
) {
    const options = captionAiToneOfVoiceOptions(t).filter((option) => option.value);

    return options.map((option) => {
        return { ...option, callback: () => callback(option.value) };
    });
}
